import { Link } from 'react-router-dom';
import './SubscriptionSuccessPage.scss';

export function SubscriptionSuccessPage() {
  return (
    <main className="subscription-success-page">
      <div className="subscription-success-page__container">
        <div className="subscription-success-page__content">
          <span className="subscription-success-page__icon">🎉</span>
          <h1 className="subscription-success-page__title">You're now Pro!</h1>
          <p className="subscription-success-page__subtitle">Your subscription is active.</p>
          <ul className="subscription-success-page__features">
            <li className="subscription-success-page__feature">Unlimited shares per day</li>
            <li className="subscription-success-page__feature">Up to 100MB per request</li>
            <li className="subscription-success-page__feature">"Never expire" option for shared requests</li>
          </ul>
          <Link to="/" className="subscription-success-page__cta">
            Start sharing
          </Link>
        </div>
      </div>
    </main>
  );
}
